/*
=====================================
    Popover: Game Canvas
=====================================
*/
import {setAttributes, hasClass, addClass, removeClass, toggleClass}  from './helper.js';

export class Popover {
    constructor(){
        this.elements = document.getElementsByClassName('js-popover');            
        this.selectedTrigger = false;
        this.popoverVisibleClass = 'popover--is-visible';
        this.selectedTriggerClass = 'popover-control--active';
        this.popoverIsOpen = false;
        this.initPopover(this);
        this.initPopoverEvents(this);
    }

    initPopover(popover) {
        // init aria-labels
        for(var i = 0; i < popover.elements.length; i++) {
            const elementId = popover.elements[i].getAttribute('id');
            const trigger = document.querySelector('[aria-controls="'+elementId+'"]');
            setAttributes(trigger, {'aria-expanded': 'false', 'aria-haspopup': 'true'});
        }
    }
    initPopoverEvents(popover) {
        var that = this;

        for(var i = 0; i < popover.elements.length; i++) {
            const element = popover.elements[i];
            const elementId = element.getAttribute('id');
            const trigger = document.querySelector('[aria-controls="'+elementId+'"]');
            const close = document.getElementById('hint-close-'+elementId.substr(5));
            trigger.addEventListener('click', function(event){
                // First reset all
                that.closeAll(popover, false);
                if(hasClass(element, popover.popoverVisibleClass) && popover.selectedTrigger !=  trigger) {
                    that.togglePopover(popover, element, false); // close menu
                }
                popover.selectedTrigger = trigger;
                
                that.togglePopover(popover, element, !hasClass(element, popover.popoverVisibleClass), true);
                
            });

            close.addEventListener('click', function(event){
                that.togglePopover(popover, element, false);
            });
        }        
    }
    togglePopover(popover, element, bool) {
        // toggle popover visibility
        toggleClass(element, popover.popoverVisibleClass, bool);
        popover.popoverIsOpen = bool;
        if(bool) {
            popover.selectedTrigger.setAttribute('aria-expanded', 'true');
            // add class to popover trigger
            addClass(popover.selectedTrigger, popover.selectedTriggerClass);
        } else if(popover.selectedTrigger) {
            popover.selectedTrigger.setAttribute('aria-expanded', 'false');
            // remove class from menu trigger
            removeClass(popover.selectedTrigger, popover.selectedTriggerClass);
            popover.selectedTrigger = false;
        }
    }
    closeAll(popover, bool) {

        for(var i = 0; i < popover.elements.length; i++) {
            
            toggleClass(popover.elements[i], popover.popoverVisibleClass, bool);
            if(popover.selectedTrigger){
                popover.selectedTrigger.setAttribute('aria-expanded', 'false');
                popover.selectedTrigger = false;
            }
        }

    }
}